import { motion } from 'framer-motion';
import { STATS } from '@/data/content';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';

export default function Stats() {
  return (
    <section className="relative border-b border-white/5 bg-night" data-testid="stats-section">
      <motion.div
        variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
        className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20 grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6"
      >
        {STATS.map((s, i) => (
          <motion.div key={s.label} variants={fadeUp} custom={i} className={`text-center lg:text-left ${i > 0 ? 'lg:border-l lg:border-white/10 lg:pl-10' : ''}`}>
            <div className="font-display text-5xl sm:text-6xl xl:text-7xl leading-none text-white" data-testid={`stat-value-${i}`}>
              {s.value === 'PRO' ? <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-goldlight to-brand-gold">PROFESSIONAL</span> : s.value}
            </div>
            <div className="mt-3 text-xs sm:text-sm uppercase tracking-[0.25em] text-brand-gold font-semibold">{s.label}</div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
